import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
const { clinicId } = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{denialResponseDtos:MasterTableDataType[],totalCount:number}>>=>{
    const result = await instance.post(`${MastersApi.getAllDenialCode}`,{...params,clinicId});
    return result.data;
}


export const saveMasterData = async (params:MasterDataType):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.saveDenialCode}`,params);
    return result.data;
}

